import { render, staticRenderFns } from "./bottomScroller.vue?vue&type=template&id=3c22ceb3&scoped=true"
import script from "./bottomScroller.vue?vue&type=script&lang=js"
export * from "./bottomScroller.vue?vue&type=script&lang=js"
import style0 from "./bottomScroller.vue?vue&type=style&index=0&id=3c22ceb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22ceb3",
  null
  
)

export default component.exports